import { connect, FormikContextType, getIn } from 'formik';
import React from 'react';
import { ProfilePictureCard } from 'src/UIKit';
import { ImageUpload } from '~/Components/ImageUpload';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { useRequest, useUUID } from '~/Hooks';
import { makeStyles } from '~/UIKit/Style';
import { ExtendedStaff } from '../../ExtendedSaff.model';

const useStyles = makeStyles((theme) => ({
  imageContainerClass: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  uploadImageButton: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      marginTop: theme.spacing(2),
    },
  },
}));

export interface IImageResponse {
  url: string;
}

export const StaffEditCustomImage = connect<ExtendedStaff>(
  ({ formik }: { formik: FormikContextType<ExtendedStaff> }) => {
    if (!formik) {
      return null;
    }
    const { classes } = useStyles();
    const imageUrl = getIn(formik.values, 'imageUrl');
    const { request } = useRequest();
    const { createUUID } = useUUID();

    const handleNewImage = async (imageData: string) => {
      const uploadedImage = await request<IImageResponse>({
        url: CORE_SERVICE_URLS.UPLOAD_IMAGE,
        method: 'POST',
        data: {
          name: createUUID(),
          imageData,
        },
      });

      if (uploadedImage.data?.url) {
        formik.setFieldValue('imageUrl', uploadedImage.data.url);
      }
    };

    return (
      <ProfilePictureCard
        displayName=""
        imageUrl={imageUrl}
        textCenter
        fontSize={24}
        imageSize={80}
        maxWidth={250}
        imageContainerClass={classes.imageContainerClass}
        hideLabel
        actionButton={
          <ImageUpload
            className={classes.uploadImageButton}
            onUpload={handleNewImage}
            canvasStyle={{
              width: 300,
              height: 300,
              color: [0, 0, 0, 0.4],
              borderRadius: 500,
              border: 0,
            }}
          />
        }
      />
    );
  },
);
